import React, { useState, useEffect } from 'react';
import useData from './useData';
import Switcher from './Switcher';
import HeroDonut from './HeroDonut';
import SmallDonut from './SmallDonut';

// import '../styles/donuts.styl';

const DonutsApp = () => {
  const [filter, setFilter] = useState('female');
  const data = useData();

  return (
    <div className="app-wrapper">
      <Switcher onChange={setFilter} value={filter} />
      <div className="donut__list">
        {(data && data.ready) && (
          <>
            <HeroDonut data={data.hero} selected={filter} />
            <>
            {data.list.sort(function(a,b){
              return a.parlament.localeCompare(b.parlament);
            }).map(function(p){
              return (
                <SmallDonut data={p} selected={filter} />
              )
            })}
            </>
          </>
        )}
      </div>
    </div>
  );
};

export default DonutsApp;
